import { useState } from 'react';

import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { Button, Price } from '@flipster/ui';
import ConvertIcon from '@flipster/ui/assets/svgs/convert.svg';
import Num from '@flipster/utils/num';

interface Props {
  exchangeRate?: string;
  fromCurrency?: string;
  toCurrency?: string;
  fromPrecision?: number;
  toPrecision?: number;
}

export const ExchangeRate = ({ exchangeRate, fromCurrency, toCurrency, fromPrecision, toPrecision }: Props) => {
  const [reversed, setReversed] = useState<boolean>(false);

  return (
    <div className={flex({ justify: 'flex-end', align: 'center', color: 'legacy.gray.e' })}>
      <Price
        fontType='num4'
        price={1}
        currency={reversed ? toCurrency : fromCurrency}
        precision={reversed ? toPrecision : fromPrecision}
      />
      <span className={css({ mx: 4 })}>≈</span>
      {exchangeRate ? (
        <Price
          fontType='num4'
          price={reversed ? Num(1).dividedBy(exchangeRate).toString() : exchangeRate}
          currency={reversed ? fromCurrency : toCurrency}
          precision={reversed ? fromPrecision : toPrecision}
        />
      ) : (
        '-'
      )}
      <Button
        shape='circle1'
        onClick={() => setReversed((prevState) => !prevState)}
        className={css({
          p: 3,
          ml: 6,
          bg: 'legacy.gray.8!',
          '& svg': {
            w: 11,
            h: 11,
            color: 'legacy.black',
          },
        })}
      >
        <ConvertIcon />
      </Button>
    </div>
  );
};
